<template>
  <Dialog :header="$t('settings.edit_profile')" v-model:visible="visible" @hide="visible = false"   >
    <div class="p-fluid">
      <ProfileForm :profile="my_profile" @update-profile="updateProfile"  ref="profileForm"/>
    </div>
    <template #footer>
      <Button :label="$t('settings.save')" type="submit" @click="handleSubmit" />
    </template>
  </Dialog>
</template>

<script>
import ProfileForm from './ProfileForm.vue';

export default {
  props: ['my_profile'],
  components: {
    ProfileForm,
  },
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    updateProfile(profile) {
      this.$emit('update-profile', profile);
    },
    onHide() {
      this.visible = false;
    },
    openDialog() {
      this.visible = true;
    },
    saveProfile() {
      this.visible = false;
    },
    handleSubmit() {
      this.$refs.profileForm.handleSubmit();
    }
  }
}
</script>
<style>
.p-dialog-title {
  margin: auto;
}
</style>